import { IsString, IsNotEmpty, IsUUID } from 'class-validator';

export class CompanyGroupCustomNameDto {
  @IsUUID()
  @IsNotEmpty()
  value: string;

  @IsString()
  @IsNotEmpty()
  label: string;
}
